import type {
  ContractAccountingStatusModel,
  ContractModel,
  ContractsRepository,
  ProductConditionsModel,
} from '@/Contract/domain'
import { ContractForm } from '@/Contract/ui/hooks'
import { HttpModel } from '@/Shared/domain'

interface IContracts {
  getBillingData: (merchantTargetId: number) => Promise<HttpModel<ContractModel>>
  saveBillingData: (data: ContractForm) => Promise<HttpModel<boolean>>
  getProductConditions: (
    merchantTargetId: number,
    productId: number,
  ) => Promise<HttpModel<ProductConditionsModel>>
  getAccountingStatus: (
    merchantTargetId: number,
  ) => Promise<HttpModel<ContractAccountingStatusModel>>
  processUnpaidInvoices: (merchantTargetId: number) => Promise<HttpModel<boolean>>
}

export const ContractsContract = (storesRepository: ContractsRepository): IContracts => ({
  getBillingData: async (merchantTargetId: number): Promise<HttpModel<ContractModel>> =>
    await storesRepository.GetBillingData(merchantTargetId),
  saveBillingData: async (data: ContractForm): Promise<HttpModel<boolean>> =>
    await storesRepository.SaveBillingData(data),
  getProductConditions: async (
    merchantTargetId: number,
    productId: number,
  ): Promise<HttpModel<ProductConditionsModel>> =>
    await storesRepository.GetProductConditions(merchantTargetId, productId),
  getAccountingStatus: async (
    merchantTargetId: number,
  ): Promise<HttpModel<ContractAccountingStatusModel>> =>
    await storesRepository.GetAccountingStatus(merchantTargetId),
  processUnpaidInvoices: async (merchantTargetId: number): Promise<HttpModel<boolean>> =>
    await storesRepository.ProcessUnpaidInvoices(merchantTargetId),
})
